import { initI18n } from '@/lib/i18n'
import { RouterContext } from '@/main'
import { getLocale } from '@/stores/i18n'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import i18n from 'i18next'

void initI18n(i18n, { language: getLocale(), document }).catch((err: unknown) => {
  console.error('i18n init failed', err)
})

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
})
